export default {
  SET_userNotification(state, value) {
    state.userNotification = value;
  },
};
